'use client';

import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';
import { trackError } from '@/lib/analytics';

export function GlobalErrorHandler() {
  const { user } = useUser();

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      trackError(
        'javascript_error',
        event.message,
        'global_error_handler',
        user?.primaryEmailAddress?.emailAddress,
        {
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
          stack: event.error?.stack,
          user_agent: navigator.userAgent,
          user_id: user?.id,
          timestamp: new Date().toISOString()
        }
      );
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      trackError(
        'unhandled_promise_rejection',
        event.reason?.message || String(event.reason),
        'global_error_handler',
        user?.primaryEmailAddress?.emailAddress,
        {
          reason: event.reason,
          stack: event.reason?.stack,
          user_agent: navigator.userAgent,
          user_id: user?.id,
          timestamp: new Date().toISOString()
        }
      );
    };

    // Add global error listeners
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup listeners on unmount
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [user]);

  return null; // This component doesn't render anything
}